// extracted by mini-css-extract-plugin
export default {"wrap":"LH-z","articleImagesWrap":"MH-z","articleImage":"NH-z","singleImage":"OH-z"};